import { useState, useImperativeHandle, FC } from 'react';
import BaseModal from '@/components/BaseModal';
import { calcNum } from '../../config';
import { isEnv } from '@/utils';
import './index.scss';

interface propsType {
  cRef?: any;
  datas: any;
  checked: boolean;
  openRemined: any;
  seriesState: number;
}
const SignInSuccess: FC<propsType> = (props) => {
  const { cRef, datas, checked, openRemined, seriesState } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  console.log(datas);
  /**
   * @description: 切换弹框状态
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 关闭弹框
   */
  const close = () => {
    setShow(false);
  };
  /**
   * @description: 获取奖品数量
   */
  const getNum = (dataIndex: number, type: number) => {
    if (datas && datas.signinQueryDetailList) {
      const num: any = calcNum(
        datas.signinQueryDetailList[dataIndex],
        type,
        seriesState,
      );
      return num;
    }
    return 0;
  };
  /**
   * @description: 获取菜品名称
   * type 1菜品  2数量
   * dishes 逗号分隔
   */
  const getDishes = (dataIndex: number, type: number) => {
    if (datas && datas.signinQueryDetailList[dataIndex].dishes) {
      const dishesArr = datas.signinQueryDetailList[0].dishes.split(',');
      const dishesLength = dishesArr.length;
      return type === 1
        ? dishesLength > 1
          ? `${dishesArr[0]}等${dishesLength}个菜品`
          : dishesArr[0]
        : dishesLength;
    }
    return '';
  };
  /**
   * @description: 开启提醒
   */
  const todo = async () => {
    if (checked) {
      //我知道了
      setShow(false);
      return;
    }
    openRemined && openRemined({ type: 'open', needApi: true });
  };
  //判断数组中是否有null
  const hasNull = () => {
    return (
      datas &&
      datas.signinQueryDetailList &&
      datas.signinQueryDetailList.some((e: any) => e === null)
    );
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    open,
    close,
  }));
  return (
    <BaseModal show={show}>
      <div className="signin-success">
        <div className="success__header">
          <img
            src={require('@/images/signIn/icon_success_title.png')}
            alt=""
            className="success__header__title"
          />
          <img
            src={require('@/images/signIn/icon_success.png')}
            alt=""
            className="success__header__success"
          />
        </div>
        <div className="success__body">
          <p className="success__body__today">恭喜您今日获得</p>
          {/* two */}
          <div
            className={`success__body__content today ${
              getNum(0, 4) <= 2 ? 'two' : ''
            }`}
          >
            {getNum(0, 1) > 0 && (
              <div className="success__body__content__item">
                <img
                  src={require('@/images/signIn/signin_fragment.png')}
                  alt=""
                />
                <p>
                  <span>碎片{getNum(0, 1)}</span>
                </p>
              </div>
            )}
            {getNum(0, 2) > 0 && (
              <div className="success__body__content__item">
                <img src={require('@/images/signIn/signin_money.png')} alt="" />
                <p>
                  <span>成长值{getNum(0, 2)}</span>
                </p>
              </div>
            )}
            {getDishes(0, 2) > 0 && (
              <div className="success__body__content__item">
                <img src={require('@/images/signIn/signin_gift.png')} alt="" />
                <p>
                  <span>{getDishes(0, 1)}</span>
                </p>
              </div>
            )}
          </div>
          <p className="success__body__tomorrow">
            {hasNull() ? '明日签到还可领福利' : '明日签到可获得'}
          </p>
          <div
            className={`success__body__content tomorrow ${
              getNum(0, 4) <= 2 ? 'two' : ''
            }`}
          >
            {getNum(1, 1) > 0 && (
              <div className="success__body__content__item">
                <img
                  src={require('@/images/signIn/signin_fragment.png')}
                  alt=""
                />
                <p>
                  <span>碎片{getNum(1, 1)}</span>
                </p>
              </div>
            )}
            {getNum(1, 2) > 0 && (
              <div className="success__body__content__item">
                <img src={require('@/images/signIn/signin_money.png')} alt="" />
                <p>
                  <span>成长值{getNum(1, 2)}</span>
                </p>
              </div>
            )}
            {getNum(1, 3) > 0 && (
              <div className="success__body__content__item">
                <img src={require('@/images/signIn/signin_gift.png')} alt="" />
                <p>
                  <span>
                    {datas.signinQueryDetailList[1].dishesKey}x
                    {datas.signinQueryDetailList[1].dishesCount}
                  </span>
                </p>
              </div>
            )}
            {/* 第七天 */}
            {hasNull() && (
              <div className="success__body__content__item day7">
                <img
                  src={require('@/images/signIn/signin_chest_shadow.png')}
                  alt=""
                  className="shadow"
                />
                <img src={require('@/images/signIn/signin_chest.png')} alt="" />
              </div>
            )}
          </div>
          {/* 按钮  success_btn2*/}
          <img
            src={require(`@/images/signIn/success_btn${
              !checked && isEnv() === 'App' ? '1' : '2'
            }.png`)}
            alt=""
            className="success__body__btn"
            onClick={todo}
          />
          {/* 提示 */}
          {getDishes(0, 2) > 0 && (
            <p className="success__body__tips">
              领取的菜品可在【我的券包】中查看
            </p>
          )}
        </div>
        <img
          src={require('@/images/signIn/success_close.png')}
          alt=""
          className="success__close"
          onClick={close}
        />
      </div>
    </BaseModal>
  );
};

export default SignInSuccess;
